<template>
  <el-container type="flex" class="main_container">
    <base-header>
      <el-input
        style="width: 220px; margin-right: 10px"
        v-model="keyword"
        placeholder="请输入用户昵称/手机号/userID"
        @keyup.enter.native="search"
      >
      </el-input>
      <el-button @click="search" :loading="searchLoading"> 搜索 </el-button>
      <el-button @click="reset" :loading="resetLoading"> 重置 </el-button>
      <el-button class="clickable" @click="usrExchange"> 用户换绑 </el-button>
    </base-header>
    <el-main style="border-color: #c2e7">
      <el-table :data="client_list" height="100%" v-loading="tableLoading">
        <el-table-column
          prop="client_id"
          label="userID"
          align="left"
          width="80"
        >
        </el-table-column>
        <el-table-column label="微信头像和昵称" width="140">
          <template v-slot="scope">
            <div class="clickable" @click="toUserManager(scope.row.client_id)">
              <img v-if="scope.row.avatar_url" :src="scope.row.avatar_url" />
              {{ scope.row.nickname }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="分销上级" width="140">
          <template v-slot="scope">
            <div>
              <img
                v-if="scope.row.boss_avatar_url"
                :src="scope.row.boss_avatar_url"
              />
              {{ scope.row.boss_nickname }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="来源小程序" width="160">
          <template v-slot="scope">
            <div>
              {{ scope.row.app_id }}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="is_seller" width="120" align="center">
          <template slot="header" slot-scope="scope">
            <el-checkbox v-model="get_seller" @change="getList">
              <span style="font-size: 12px; color: #909399; font-weight: 700"
                >只显示团长</span
              >
            </el-checkbox>
          </template>
          <template v-slot="scope">
            <el-tag :type="scope.row.is_seller === 1 ? 'primary' : 'success'">{{
              scope.row.identify
            }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="团长审核">
          <template v-slot="scope">
            <el-checkbox
              :disabled="!!scope.row.seller_approval"
              v-show="!scope.row.is_seller"
              v-model="scope.row.checked"
              @change="becomeSeller($event, scope.row)"
              >&emsp;</el-checkbox
            >
          </template>
        </el-table-column>
        <el-table-column label="关注品牌商" width="120">
          <template v-slot="scope">
            <el-tag
              v-show="!!scope.row.is_seller"
              class="clickable"
              effect="dark"
              type="primary"
              @click="openBranderDialog(scope.$index)"
            >
              关注列表
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="设置通知店铺" width="120">
          <template v-slot="scope">
            <el-tag
              v-show="!!scope.row.is_seller"
              class="clickable"
              effect="dark"
              type="primary"
              @click="addSomething(scope)"
            >
              设置通知店铺
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="获取店铺订单" width="130">
          <template v-slot="scope">
            <el-tag
              v-show="!!scope.row.is_seller"
              class="clickable"
              effect="dark"
              type="primary"
              @click="setGroupChatList(scope)"
            >
              获取店铺订单
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="拥有的机器人" width="180">
          <template v-slot="scope">
            <div class="align-center">
              <div class="align-center" style="width: 230px">
                <img
                  v-if="scope.row.BotAvatarUrl"
                  :src="scope.row.BotAvatarUrl"
                />
                <div>{{ scope.row.BotNickname }}</div>
              </div>
              <el-dropdown
                v-if="scope.row.BotNickname"
                :hide-on-click="false"
                @visible-change="
                  (value) => {
                    hideChangeChatroomCount(value, scope.$index);
                  }
                "
                @command="
                  (command) => {
                    handleCommand(command, scope.row);
                  }
                "
              >
                <el-tag class="clickable">操作</el-tag>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="a">换绑</el-dropdown-item>
                  <el-dropdown-item command="b">
                    <span v-show="scope.row.changingChatroomCount === false"
                      >更改进群数量</span
                    >
                    <el-input
                      v-show="scope.row.changingChatroomCount"
                      style="width: 80px"
                      v-model="chatroom_count"
                      @change="changeChatroomCount"
                    />
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="进群数量">
          <template v-slot="scope">
            <span
              style="color: dodgerblue; margin-right: 10px"
              v-if="scope.row.BotNickname"
            >
              {{ scope.row.chatroom_used + "/" + scope.row.chatroom_count }}
            </span>
          </template>
        </el-table-column>
        <!-- 商场项目配置 -->
        <el-table-column label="商场项目配置" width="300" align="center">
          <template v-slot="scope">
            <template>
              <el-tag
                class="clickable"
                effect="dark"
                type="primary"
                @click="bindproject(scope)"
                v-if="!scope.row.project_name"
              >
                点击配置
              </el-tag>
              <span v-else>
                项目 : {{ scope.row.project_name }} 商场标识 :
                {{ scope.row.project_key_words }}
                <br />
                密钥 : {{ scope.row.docking_secret }}
                <br />
                <!-- <el-popover
                  placement="top"
                  width="80px"
                  v-model="scope.row.visiblel"
                >
                  <p style="color: red">确定取消配置吗？</p>
                  <div style="text-align: right; margin: 0">
                    <el-button
                      size="mini"
                      type="text"
                      @click="scope.row.visiblel = false"
                      >取消</el-button
                    >
                    <el-button
                      type="primary"
                      size="mini"
                      @click="delproject(scope)"
                      >确定</el-button
                    >
                  </div>
                  <el-button
                    slot="reference"
                    type="primary"
                    size="mini"
                    
                    >取消配置</el-button
                  >
                </el-popover> -->
              </span>
            </template>
          </template>
        </el-table-column>

        <el-table-column label="同城配送" width="140">
          <template v-slot="scope">
            <p @click="openDialog(scope.$index)">查看</p>
          </template>
        </el-table-column>
        <el-table-column label="添加配送员" width="140">
          <template v-slot="scope">
            <el-switch
              v-model="scope.row.has_mansion_delivery"
              @change="(value) => setMansionDelivery(value, scope.row)"
            />
          </template>
        </el-table-column>
        <el-table-column label="设置为点餐大使" width="140">
          <template v-slot="scope">
            <el-switch
              v-model="scope.row.is_mansion_seller"
              @change="
                changeSwitchDS($event, scope.row, 'bmclient/set_mansion_seller')
              "
            />
          </template>
        </el-table-column>
        <el-table-column label="设置为美团页面" width="140">
          <template v-slot="scope">
            <el-switch
              v-model="scope.row.waimai_meituan_page"
              @change="(value) => setMeituanPage(value, scope.row)"
            />
          </template>
        </el-table-column>
        <el-table-column label="预设配送地址" width="120">
          <template v-slot="scope">
            <el-tag
              class="clickable"
              effect="dark"
              type="primary"
              @click="addrDialog(scope.row)"
            >
              添加地址
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column width="120" align="center">
          <template slot="header" slot-scope="scope">
            <el-checkbox v-model="has_minfu" @change="getList"
              ><span style="font-size: 12px; color: #909399; font-weight: 700"
                >提现设置</span
              ></el-checkbox
            >
          </template>
          <template v-slot="scope">
            <span v-show="scope.row.has_minfu" style="color: orangered"
              >银行卡</span
            >
            <span v-show="!scope.row.has_minfu" style="color: #999999"
              >微信零钱</span
            >
            <el-tag
              type="primary"
              class="clickable"
              style="margin-left: 5px"
              size="mini"
              @click="openDialog1(scope.$index)"
              >详情</el-tag
            >
          </template>
        </el-table-column>
        <el-table-column
          prop="phone"
          label="手机号码"
          align="center"
          width="140"
        >
          <template v-slot="scope">
            <div>
              {{ scope.row.phone }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="create_group_buy_count"
          label="发布接龙(个)"
          align="center"
        >
          <template v-slot="scope">
            <div @click="openCount(scope.row.client_id)" class="group-buy-info">
              {{ scope.row.create_group_buy_count }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          v-for="item in table_column"
          :key="item.index"
          :prop="item.prop"
          :label="item.label"
          :align="item.align"
          :width="item.width"
        ></el-table-column>
        <el-table-column label="账户详情" align="center">
          <template v-slot="scope">
            <p @click="openDetail(scope.row)">查看</p>
          </template>
        </el-table-column>
        <el-table-column label="跳转PC后台" align="center" width="100">
          <template v-slot="scope">
            <p @click="toUserManager(scope.row.client_id)">跳转链接</p>
          </template>
        </el-table-column>
        <el-table-column
          label="获取邀请品牌商二维码"
          align="center"
          width="100"
        >
          <template v-slot="scope">
            <el-popover
              placement="top-start"
              width="200"
              trigger="hover"
              @show="getCode(scope.row)"
            >
              <div v-if="!scope.row.qrCode">加载中</div>
              <img
                v-else
                :src="scope.row.qrCode"
                alt=""
                style="width: 100px; height: 100px"
              />
              <icon-svg
                slot="reference"
                icon-class="erweima"
                size="2em"
              ></icon-svg>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column label="注销/恢复账号" align="center" width="220">
          <template v-slot="scope">
            <div
              v-show="
                scope.row.is_brander ||
                scope.row.is_seller ||
                scope.row.is_cancel >= 0
              "
            >
              <div v-show="!scope.row.is_cancel">
                <el-popover
                  placement="top"
                  width="80px"
                  v-model="scope.row.writeOffVisible"
                >
                  <p style="color: red">确定注销该账号吗？</p>
                  <div style="text-align: right; margin: 0">
                    <el-button
                      size="mini"
                      type="text"
                      @click="scope.row.writeOffVisible = false"
                      >取消</el-button
                    >
                    <el-button
                      type="primary"
                      size="mini"
                      @click="writeOff(scope)"
                      >确定</el-button
                    >
                  </div>
                  <el-button
                    slot="reference"
                    type="primary"
                    size="mini"
                    
                    >注销账号</el-button
                  >
                </el-popover>
              </div>
              <div v-show="scope.row.is_cancel">
                <div class="write-off">已注销</div>
                <el-button type="primary" size="mini" @click="recover(scope)"
                  >恢复账号</el-button
                >
              </div>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </el-main>
    <el-footer class="footer">
      <el-pagination
        :total="totalCount"
        :page-size="pagesize"
        :current-page="page"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        layout="total, sizes, prev, pager, next, jumper"
      >
      </el-pagination>
    </el-footer>
    <template v-if="client_list.length > 0">
      <el-dialog :visible.sync="visible" :title="dialogTitle" width="30%">
        <client-detail :client-id="dialogId" :key="flag"></client-detail>
      </el-dialog>
      <el-dialog
        :visible.sync="dialogVisible"
        :title="`${
          client_list[targetRow] && client_list[targetRow].nickname
        }  同城配送`"
        width="50%"
      >
        <el-row
          v-for="(item, index) in targetShopList"
          :key="item.store_id"
          type="flex"
          align="middle"
          :style="{ marginTop: index ? '30px' : '0' }"
        >
          <el-col :span="8">
            <div
              v-if="item.delivery_id === 'MTPS'"
              class="a-icon"
              style="background-color: rgb(255, 196, 0)"
            >
              美团
            </div>
            <div
              v-if="item.delivery_id === 'DADA'"
              class="a-icon"
              style="background-color: #3a8ee6; color: white"
            >
              达达
            </div>
            <div
              v-if="item.delivery_id === 'SFTC'"
              class="a-icon"
              style="background-color: black; color: white"
            >
              顺丰
            </div>
            <div v-if="!item.store_id" style="color: #666666">&nbsp;未接入</div>
            <div v-else style="color: red">&nbsp;已接入</div>
          </el-col>
          <el-col :span="8">
            <p @click="showShopForm(item.delivery_id, item.store_id)">
              {{ item.store_id ? "修改" : "接入" }}
            </p>
          </el-col>
          <el-col :span="8">
            <el-radio
              v-if="item.store_id"
              v-model="usedShop"
              :label="item.delivery_id"
              @change="useStore(item.store_id, index)"
              >当前使用</el-radio
            >
          </el-col>
        </el-row>
      </el-dialog>
      <el-dialog
        :visible.sync="shopFormVisible"
        :title="`${
          client_list[targetRow] && client_list[targetRow].nickname
        }  店铺信息`"
        width="50%"
      >
        <el-form :model="shopInfo" label-width="100px">
          <el-form-item
            :label="item.name"
            v-for="item in shopInfoItem"
            :key="item.name"
          >
            <el-input
              v-model="shopInfo[item.value]"
              style="width: 400px"
            ></el-input>
          </el-form-item>
          <el-form-item style="display: flex; justify-content: center">
            <el-button @click="hideDialog">取消</el-button>
            <el-button type="primary" @click="onSubmit">确定</el-button>
          </el-form-item>
        </el-form>
      </el-dialog>
      <el-dialog
        :visible.sync="botListVisible"
        :title="`${targetChangeBotRow.nickname}  机器人换绑`"
        width="30%"
      >
        <div>
          <div class="align-center" style="padding: 10px">
            <div>现有机器人：</div>
            <img
              v-if="targetChangeBotRow.BotAvatarUrl"
              :src="targetChangeBotRow.BotAvatarUrl"
            />
            <div>{{ targetChangeBotRow.BotNickname }}</div>
          </div>
          <div class="align-center" style="padding: 10px">
            <div>更换机器人：</div>
            <el-select
              v-model="targetBot"
              filterable
              placeholder="请选择(可搜索)"
            >
              <el-option
                v-for="item in botList"
                :key="item.bot_username"
                :label="item.bot_nickname"
                :value="item.bot_username"
              >
              </el-option>
            </el-select>
          </div>
          <div style="padding: 10px">
            <el-button type="primary" @click="changeBot" :disabled="!targetBot"
              >确定</el-button
            >
          </div>
        </div>
      </el-dialog>
      <el-dialog
        :visible.sync="branderListVisible"
        :title="`${
          client_list[targetRow] && client_list[targetRow].nickname
        }  关注品牌商列表`"
        width="80%"
      >
        <div>
          <el-input
            v-model="branderSearchWord"
            placeholder="请输入手机号/昵称/ID"
            style="width: 300px; margin-right: 10px"
            @keyup.enter.native="searchBranderList"
          />
          <el-button
            size="mini"
            :disabled="!branderSearchWord"
            @click="searchBranderList"
            >搜索</el-button
          >
          <el-button size="mini" @click="getClientFollowBranderList"
            >重置</el-button
          >
        </div>
        <el-table :data="branderList" show-header="false" style="width: 100%">
          <el-table-column width="150px">
            <template v-slot="scope">
              <img :src="scope.row.avatar_url" />
              <span>{{ scope.row.nickname }}</span>
            </template>
          </el-table-column>
          <el-table-column width="150px">
            <template v-slot="scope">
              <img :src="scope.row.shop_pic" />
              <span>{{ scope.row.shop_name }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="client_id" width="50px"> </el-table-column>
          <el-table-column prop="phone" width="100px;"> </el-table-column>
          <el-table-column width="130px">
            <template slot-scope="scope">
              <div style="display: flex">
                <span style="margin-right: 10px">评分</span>
                <span
                  v-show="!scope.row.changingScore"
                  style="display: inline-block; width: 30px"
                  @click="scope.row.changingScore = true"
                  >{{ scope.row.score }}</span
                >
                <el-input
                  v-show="scope.row.changingScore"
                  v-model="scope.row.score"
                  size="mini"
                  style="width: 50px"
                  @keyup.enter.native="changeScore(scope.row)"
                  @blur="changeScore(scope.row)"
                >
                </el-input>
              </div>
            </template>
          </el-table-column>
          <el-table-column width="230px">
            <template v-slot="scope">
              <el-button
                v-for="(tag, index) in tagList"
                :key="index"
                :type="index + 1 === scope.row.shop_size ? 'primary' : ''"
                class="clickable tag-item"
                style="user-select: none"
                size="mini"
                :disabled="!scope.row.is_follow"
                @click="clickTag(scope.row, index + 1)"
              >
                {{ tag }}
              </el-button>
            </template>
          </el-table-column>
          <el-table-column v-slot="scope" width="100px;">
            <el-popover
              v-show="scope.row.is_follow"
              placement="top"
              width="160"
              v-model="scope.row.cancelVisible"
            >
              <p>确认取消关注吗？</p>
              <div style="text-align: right; margin: 0">
                <el-button
                  size="mini"
                  type="text"
                  @click="scope.row.cancelVisible = false"
                  >取消</el-button
                >
                <el-button
                  type="primary"
                  size="mini"
                  @click="cancelFollowBrander(scope.row)"
                  >确定</el-button
                >
              </div>
              <el-button
                slot="reference"
                type="primary"
                
                >取消关注</el-button
              >
            </el-popover>
            <el-popover
              v-show="!scope.row.is_follow"
              placement="top"
              width="160"
              v-model="scope.row.visible"
            >
              <p>确认关注吗？</p>
              <div style="text-align: right; margin: 0">
                <el-button
                  size="mini"
                  type="text"
                  @click="scope.row.visible = false"
                  >取消</el-button
                >
                <el-button
                  type="primary"
                  size="mini"
                  @click="followBrander(scope.row)"
                  >确定</el-button
                >
              </div>
              <el-button
                slot="reference"
                type="success"
                
                >确认关注</el-button
              >
            </el-popover>
          </el-table-column>
        </el-table>
      </el-dialog>
      <el-dialog
        title="设置通知店铺"
        :visible.sync="addSomethingVisible"
        width="60%"
      >
        <template>
          <el-table :data="toShowList" max-height="400" style="width: 100%">
            <el-table-column>
              <template git v-slot="scope">
                <el-checkbox v-model="scope.row.is_add">添加</el-checkbox>
              </template>
            </el-table-column>
            <el-table-column label="店铺信息">
              <template v-slot="scope">
                <img :src="scope.row.shop_pic" />
                <span>{{ scope.row.shop_name }}</span>
              </template>
            </el-table-column>
          </el-table>
        </template>
        <div slot="footer" class="dialog-footer">
          <el-button type="primary" @click="addSomethingSubmit"
            >提 交</el-button
          >
        </div>
      </el-dialog>
      <el-dialog
        title="设置服务通知群"
        :visible.sync="addGroupChatVisible"
        width="40%"
      >
        <div>
          <div
            v-for="(item, index) in interList"
            :key="index"
            style="margin-bottom: 10px; padding-left: 20px"
          >
            {{ item }}
          </div>
        </div>
      </el-dialog>
      <el-dialog
        :visible.sync="minfuVisible"
        width="30%"
        @close="changingRate = false"
      >
        <div
          style="
            line-height: 30px;
            padding: 10px;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
          "
        >
          <div>
            <div style="display: flex">
              <span>当前提现渠道</span>
              <div style="margin-left: 20px">
                <div>
                  <el-radio
                    v-model="rateType"
                    :disabled="!!client_list[targetRow].has_minfu"
                    label="0"
                    >微信零钱</el-radio
                  >
                </div>
                <div>
                  <el-radio v-model="rateType" label="1" @change="switchToMinfu"
                    >银行卡（敏付）</el-radio
                  >
                </div>
              </div>
            </div>
            <div style="margin-top: 30px">
              <span>当前提现费率：</span>
              <span
                v-show="!changingRate"
                style="display: inline-block; width: 80px"
                >{{ rate }}%</span
              >
              <el-input
                v-show="changingRate"
                v-model="rate"
                size="mini"
                style="width: 80px"
                @keyup.enter.native="changeRate"
                @blur="changeRate"
              >
              </el-input>
              <el-tag
                type="primary"
                size="mini"
                class="clickable"
                style="margin-left: 10px"
                @click="changingRate = true"
              >
                修改
              </el-tag>
            </div>
            <div style="color: #999999; font-size: 12px">
              费率可修改范围为：0.6%-20%
            </div>
            <div style="margin-top: 30px" v-show="rateType === '1'">
              当前旧账户余额：{{ client_list[targetRow].balance }}元
            </div>
          </div>
        </div>
      </el-dialog>
      <!-- 商场项目配置弹窗 -->
      <el-dialog
        title="商场项目配置"
        :visible.sync="showbindDialog"
        width="30%"
        :before-close="handleClose"
        center
      >
        <el-form
          ref="projectFrom"
          :model="projectFrom"
          label-width="100px"
          :rules="projectFromrules"
        >
          <el-form-item
            label="项目 : "
            prop="project_name"
            class="projectdialog"
          >
            <el-select
              v-model="projectFrom.project_name"
              style="width: 200px"
              size="mini"
              placeholder="请选择项目"
            >
              <el-option
                v-for="(item, index) in projectList"
                :key="index"
                :label="item"
                :value="item"
              />
            </el-select>
          </el-form-item>
          <el-form-item
            label="商场标识 : "
            prop="project_key_words"
            class="projectdialog"
          >
            <el-input
              v-model="projectFrom.project_key_words"
              style="width: 200px"
              placeholder="请输入商场标识"
              size="mini"
            ></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="submitproject('projectFrom')"
            >确定配置</el-button
          >
        </span>
      </el-dialog>
    </template>
    <addr-dialog :show.sync="addrDialogVisible" :t_client_id="t_client_id" />
    <user-exchange :show.sync="userExchangeVisible" />
  </el-container>
</template>

<script>
import pageMixin from "../../../mixins/page";
import ClientDetail from "./ClientDetail";
import getTokenMixin from "../../../mixins/getToken";
import AddrDialog from "./components/AddrDialog";
import UserExchange from "./components/UserExchange";
export default {
  name: "Client",
  components: { ClientDetail, AddrDialog, UserExchange },
  mixins: [pageMixin, getTokenMixin],
  data() {
    return {
      getProject: this.getDomain() + "CommonBranderDock/get", //获取商场项目
      creatProject: this.getDomain() + "CommonBranderDock/set_dock", //配置商场项目
      delProject: this.getDomain() + "CommonBranderDock/dock", //配置商场项目
      ClientListURL: this.getDomain() + "bmclient/get_client_list", // 用户列表
      setSellerUrl: this.getDomain() + "bmclient/set_seller", // 设为团长
      clientDetailUrl: this.getDomain() + "bmclient/get_account_info", // 用户详情
      becomeStoreSellerUrl: this.getDomain() + "bmuser/become_store_seller",
      botListURL: this.getDomain() + "bmbot/get_bot_list",
      changeBotUrl: this.getDomain() + "bmclient/change_bot",
      changeChatroomCountUrl: this.getDomain() + "bmuser/change_chatroom_count",
      becomeBranderQrCodeUrl:
        this.getDomain() + "bmclient/get_client_become_brander_qrcode",
      getClientFollowBranderListUrl:
        this.getDomain() + "bmclient/get_client_follow_brander_list",
      getAlreadySubmitURL: this.getDomain() + "bmclient/get_need_send_branders",
      addSomethingSubmitURL:
        this.getDomain() + "bmclient/set_need_send_branders",
      getGroupChatListURL: this.getDomain() + "bmclient/mansion_order_count",
      submitGroupChatListURL:
        this.getDomain() + "bmclient/set_mansion_server_chatroom",
      cancelFollowBranderUrl:
        this.getDomain() + "bmclient/cancel_follow_brander",
      followBranderUrl: this.getDomain() + "bmclient/follow_brander",
      modifyBranderShopSizeUrl:
        this.getDomain() + "bmclient/modify_brander_shop_size",
      accountCancelOrRecovery:
        this.getDomain() + "bmclient/account_cancel_or_recovery",
      showbindDialog: false,
      projectFrom: {
        project_name: "",
        project_key_words: "",
      },
      projectFromrules: {
        project_key_words: [
          { required: true, message: "商场标识不能为空", trigger: "blur" },
        ],
        project_name: [
          { required: true, message: "商场项目不能为空", trigger: "change" },
        ],
      },
      projectList: [],
      client_list: [{}],
      client_id: "",
      keyword: undefined,
      tableLoading: true,
      searchLoading: false,
      resetLoading: false,
      visible: false,
      addSomethingVisible: false,
      addGroupChatVisible: false,
      get_seller: false,
      table_column: [
        {
          prop: "joined_group_buy_count",
          label: "参与接龙(个)",
          align: "center",
        },
        {
          prop: "balance",
          label: "账户余额(元)",
          align: "center",
        },
        {
          prop: "income",
          label: "累计成交额(元)",
          align: "center",
        },
        {
          prop: "create_time",
          label: "注册时间",
          align: "center",
          width: "170",
        },
        {
          prop: "become_seller_time",
          label: "团长注册时间",
          align: "center",
          width: "170",
        },
      ],
      dialogTitle: undefined,
      dialogId: undefined,
      flag: 1,
      targetRow: 0,
      thisRow: 0,
      theRow: 0,
      alreadySubmitList: [],
      interList: [],
      dialogVisible: false,
      botListVisible: false,
      shopInfo: {},
      targetChangeBotRow: {},
      botList: [],
      targetBot: undefined,
      chatroom_count: undefined,

      branderListVisible: false,
      branderList: [],
      toShowList: [],
      branderSearchWord: undefined,

      has_minfu: false,
      minfuVisible: false,
      changingRate: false,
      rate: undefined,
      rateType: "0",
      addrDialogVisible: false,
      userExchangeVisible: false,
      t_client_id: undefined,

      targetShopType: undefined,
      shopFormVisible: false,
      targetShopList: [
        {
          client_id: undefined,
          delivery_id: "MTPS",
          is_active: undefined,
          store_id: undefined,
        },
        {
          client_id: undefined,
          delivery_id: "DADA",
          is_active: undefined,
          store_id: undefined,
        },
        {
          client_id: undefined,
          delivery_id: "SFTC",
          is_active: undefined,
          store_id: undefined,
        },
      ],
      checkboxGroup1: [],
      tagList: ["新店", "品牌", "连锁"],
      changingScore: false,
      score: undefined,
    };
  },
  computed: {
    usedShop() {
      if (this.targetShopList.filter((item) => !!item.is_active)[0]) {
        return this.targetShopList.filter((item) => !!item.is_active)[0]
          .delivery_id;
      }
    },
    shopInfoItem() {
      const lists = {
        DADA: [
          {
            name: "门店编号",
            value: "shop_no",
          },
          {
            name: "门店名称",
            value: "station_name",
          },
          {
            name: "区域名称",
            value: "area_name",
          },
          {
            name: "门店地址",
            value: "station_address",
          },
          {
            name: "城市名称",
            value: "city_name",
          },
          {
            name: "业务类型",
            value: "business",
          },
          {
            name: "联系人姓名",
            value: "contact_name",
          },
          {
            name: "联系人电话",
            value: "phone",
          },
          {
            name: "联系人身份证",
            value: "id_card",
          },
          {
            name: "门店经度",
            value: "lng",
          },
          {
            name: "门店纬度",
            value: "lat",
          },
          {
            name: "门店状态",
            value: "status",
          },
        ],
        SFTC: [
          {
            name: "门店编号",
            value: "shop_no",
          },
          {
            name: "门店名称",
            value: "station_name",
          },
          {
            name: "区域名称",
            value: "area_name",
          },
          {
            name: "门店地址",
            value: "station_address",
          },
          {
            name: "城市名称",
            value: "city_name",
          },
          {
            name: "业务类型",
            value: "business",
          },
          {
            name: "联系人姓名",
            value: "contact_name",
          },
          {
            name: "联系人电话",
            value: "phone",
          },
          {
            name: "联系人身份证",
            value: "id_card",
          },
          {
            name: "门店经度",
            value: "lng",
          },
          {
            name: "门店纬度",
            value: "lat",
          },
          {
            name: "门店状态",
            value: "status",
          },
        ],
        MTPS: [
          {
            name: "门店名称",
            value: "station_name",
          },
          {
            name: "门店地址",
            value: "station_address",
          },
          {
            name: "业务类型",
            value: "business",
          },
          {
            name: "联系人姓名",
            value: "contact_name",
          },
          {
            name: "联系人电话",
            value: "phone",
          },
          {
            name: "联系人身份证",
            value: "id_card",
          },
          {
            name: "门店经度",
            value: "lng",
          },
          {
            name: "门店纬度",
            value: "lat",
          },
          {
            name: "门店状态",
            value: "status",
          },
        ],
      };
      return lists[this.targetShopType];
    },
  },
  methods: {
    handleClose() {
      this.projectFrom = {
        project_name: "",
        project_key_words: "",
      };
      this.$refs["projectFrom"].resetFields();
      this.showbindDialog = false;
    },
    bindproject(scope) {
      this.client_id = scope.row.client_id;
      let params = {};
      let handle = (res) => {
        this.projectList = res.data.content.data;
      };
      this.__axios(this.getProject, params, handle);
      this.showbindDialog = true;
    },
    //提交商场项目
    submitproject(projectFrom) {
      this.$refs[projectFrom].validate((valid) => {
        if (valid) {
          let params = {
            client_id: this.client_id,
            project_name: this.projectFrom.project_name,
            project_key_words: this.projectFrom.project_key_words,
          };
          let handle = (res) => {
            if (res.data.err_code == 0) {
              this.$message.success("配置成功！");
              this.projectFrom = {
                project_name: "",
                project_key_words: "",
              };
              this.$refs["projectFrom"].resetFields();
              this.showbindDialog = false;
              this.getList();
            }
          };
          this.__axios(this.creatProject, params, handle);
        }
      });
    },
    //删除市场
    delproject(scope) {
      scope.row.visiblel = false;
      let params = {
        client_id: scope.row.client_id,
        is_dock: 0,
      };
      let handle = (res) => {
        this.$message.success("取消配置成功！");
        this.getList();
      };
      this.__axios(this.delProject, params, handle);
    },
    // 发布接龙个数
    openCount(clientId) {
      this.$router.push({
        name: "client-regiment",
        params: {
          client_id: clientId,
        },
      });
    },
    getList() {
      this.tableLoading = true;
      let params = {
        page: this.page,
        pagesize: this.pagesize,
        keyword: this.keyword,
        is_seller: this.get_seller * 1,
        has_minfu: this.has_minfu * 1,
      };
      let handle = (res) => {
        this.totalCount = res.data.content.total_count;
        this.client_list = res.data.content.client_list;
        this.client_list.forEach((item) => {
          item.balance = item.balance / 100;
          item.income = item.income / 100;
          item.create_time = this.timeTransform(item.create_time);
          item.checked = item.seller_approval === 1;
          item.has_minfu = !!item.has_minfu;
          item.minfu_rate = (item.minfu_rate * 100 || 1).toFixed(3);
          item.weixin_rate = (item.weixin_rate * 100 || 1).toFixed(3);
          item.identify = item.is_seller ? "团长" : "用户";
          this.$set(item, "has_mansion_delivery", !!item.has_mansion_delivery);
          this.$set(item, "waimai_meituan_page", !!item.waimai_meituan_page);
          this.$set(item, "writeOffVisible", false);
          item.is_mansion_seller = !!item.is_mansion_seller;
          let botInfoList = item.bot_info_list[0];
          if (botInfoList) {
            this.$set(item, "BotUsername", botInfoList.username);
            this.$set(item, "BotNickname", botInfoList.nickname);
            this.$set(item, "BotAvatarUrl", botInfoList.avatar_url);
            this.$set(item, "changingChatroomCount", false);
          }
          if (item.become_seller_time) {
            item.become_seller_time = this.timeTransform(
              item.become_seller_time
            );
          }
          this.$set(item, "qrCode", undefined);
        });
        this.tableLoading = false;
        this.searchLoading = false;
        this.resetLoading = false;
      };
      this.__axios(this.ClientListURL, params, handle);
    },
    // 搜索
    search() {
      this.searchLoading = true;
      this.page = 1;
      this.getList();
    },
    // 重置
    reset() {
      this.resetLoading = true;
      this.keyword = undefined;
      this.page = 1;
      this.getList();
    },
    becomeSeller($event, row) {
      if ($event === true) {
        let params = {
          t_client_id: row.t_client_id,
        };
        let handle = () => {
          row.seller_approval = 1;
        };
        this.__axios(this.setSellerUrl, params, handle);
      }
    },
    openDetail(row) {
      if (row.is_seller) {
        this.dialogTitle = row.nickname;
        this.dialogId = row.client_id;
        this.visible = true;
        this.flag++;
      } else {
        this.$message.error("用户不是团长，没有账号信息");
      }
    },
    openDialog(index) {
      this.targetRow = index;
      this.getStoreList();
    },
    openDialog1(index) {
      this.targetRow = index;
      this.minfuVisible = true;
      this.rateType = this.client_list[index].has_minfu ? "1" : "0";
      this.rate = this.client_list[index].has_minfu
        ? this.client_list[index].minfu_rate
        : this.client_list[index].weixin_rate;
    },
    openBranderDialog(index) {
      this.targetRow = index;
      this.branderListVisible = true;
      this.getClientFollowBranderList();
    },
    addSomething(scope) {
      this.thisRow = scope.$index;
      this.addSomethingVisible = true;
      this.getSomethingToShow();
    },
    setGroupChatList(scope) {
      this.theRow = scope.$index;
      this.addGroupChatVisible = true;
      this.getGroupChatList(scope);
    },
    onSubmit() {
      if (this.targetShopType === "MTPS" && this.targetShopList[0].store_id) {
        this.$message.error("美团不能修改");
      } else {
        this.shopInfo.t_client_id =
          this.client_list[this.targetRow].t_client_id;
        this.shopInfo.lng = this.shopInfo.lng * 1;
        this.shopInfo.lat = this.shopInfo.lat * 1;
        this.shopInfo.delivery_id = this.targetShopType;
        const params = this.shopInfo;
        const handle = (res) => {
          this.$message.success("操作成功");
          this.shopFormVisible = false;
          this.targetShopList.forEach((item) => {
            if (item.delivery_id === this.targetShopType) {
              item.store_id = res.data.content.store_id;
            }
          });
        };
        this.__confirm(
          `确认给${this.client_list[this.targetRow].nickname}添加门店`,
          this.__axios,
          [this.becomeStoreSellerUrl, params, handle]
        );
      }
    },
    showShopForm(type, id) {
      if (id) {
        this.getStoreDetail(id);
      } else {
        this.shopInfo = {};
      }
      this.shopFormVisible = true;
      this.targetShopType = type;
    },
    hideDialog() {
      this.shopFormVisible = false;
    },
    showBotList(row) {
      this.botListVisible = true;
      this.targetChangeBotRow = JSON.parse(JSON.stringify(row));
      this.targetBot = undefined;
    },
    changeBot() {
      if (this.targetBot) {
        let params = {
          t_client_id: this.targetChangeBotRow.t_client_id,
          new_bot_username: this.targetBot,
          old_bot_username: this.targetChangeBotRow.BotUsername,
        };
        let handle = () => {
          this.client_list.forEach((item) => {
            if (item.t_client_id === this.targetChangeBotRow.t_client_id) {
              this.botList.forEach((item2) => {
                if (item2.bot_username === this.targetBot) {
                  item.BotUsername = item2.bot_username;
                  item.BotNickname = item2.bot_nickname;
                  item.BotAvatarUrl = item2.avatar_url;
                }
              });
            }
          });
          this.targetChangeBotRow = {};
          this.botListVisible = false;
          this.targetBot = undefined;
        };
        this.__confirm("确定?", this.__axios, [
          this.changeBotUrl,
          params,
          handle,
        ]);
      }
    },
    getBotList() {
      let params = {
        page: 1,
        pagesize: 500,
      };
      let handle = (res) => {
        this.botList = res.data.content.data;
      };
      this.__axios(this.botListURL, params, handle);
    },
    handleCommand(command, row) {
      if (command === "a") {
        this.showBotList(row);
      } else if (command === "b") {
        row.changingChatroomCount = true;
      }
    },
    hideChangeChatroomCount(value, index) {
      if (value) {
        this.client_list[index].changingChatroomCount = false;
        this.targetRow = index;
        this.chatroom_count = undefined;
      }
    },
    changeChatroomCount() {
      let value = this.chatroom_count * 1;
      let target = this.client_list[this.targetRow];
      if (!isNaN(value)) {
        let params = {
          chatroom_count: value,
          t_client_id: target.t_client_id,
        };
        let handle = () => {
          target.chatroom_count = value;
        };
        this.__confirm(
          `将"${target.nickname}"的小助手"${target.BotNickname}"的进群数量从${target.chatroom_count}改成${value}？`,
          this.__axios,
          [this.changeChatroomCountUrl, params, handle]
        );
      } else {
        this.chatroom_count = undefined;
      }
    },
    getCode(row) {
      let params = {
        t_client_id: row.t_client_id,
      };
      let handle = (res) => {
        row.qrCode = res.data.content.url;
      };
      this.__axios(this.becomeBranderQrCodeUrl, params, handle);
    },

    getClientFollowBranderList() {
      this.branderSearchWord = "";
      let params = {
        t_client_id: this.client_list[this.targetRow].t_client_id,
      };
      let handle = (res) => {
        res.data.content.data.forEach((item) => {
          this.$set(item, "is_follow", 1);
          this.$set(item, "cancelVisible", false);
          this.$set(item, "visible", false);
          this.$set(item, "changingScore", false);
        });
        this.branderList = res.data.content.data;
      };
      this.__axios(this.getClientFollowBranderListUrl, params, handle);
    },
    getAlreadySubmit() {
      let params = {
        client_id: this.client_list[this.thisRow].client_id,
      };
      let handle = (res) => {
        res.data.content.brander_client_id_list.forEach((item) => {
          this.alreadySubmitList.push(item);
        });
      };
      this.__axios(this.getAlreadySubmitURL, params, handle);
    },
    getSomethingToShow() {
      this.getAlreadySubmit();
      let params = {
        t_client_id: this.client_list[this.thisRow].t_client_id,
      };
      let handle = (res) => {
        res.data.content.data.forEach((item) => {
          this.$set(item, "is_add", false);
        });
        this.toShowList = res.data.content.data;
        // 寻找重复选项
        this.alreadySubmitList.forEach((outerItem) => {
          this.toShowList.forEach((innerItem) => {
            if (Number(innerItem.client_id) === Number(outerItem)) {
              innerItem.is_add = true;
            }
          });
        });
        this.alreadySubmitList = [];
      };
      this.__axios(this.getClientFollowBranderListUrl, params, handle);
    },
    addSomethingSubmit() {
      this.addSomethingVisible = false;
      let branderClientIdList = [];
      this.toShowList.forEach((item) => {
        if (item.is_add === true) {
          branderClientIdList.push(item.client_id);
        }
      });
      let params = {
        client_id: Number(this.client_list[this.thisRow].client_id),
        brander_client_id_list: branderClientIdList,
      };
      let handle = (res) => {};
      this.__axios(this.addSomethingSubmitURL, params, handle);
    },
    getGroupChatList(scope) {
      let params = {
        client_id: scope.row.client_id,
      };
      let handle = (res) => {
        this.interList = res.data.content.res.split("\n");
      };
      this.__axios(this.getGroupChatListURL, params, handle);
    },
    cancelFollowBrander(item) {
      let params = {
        t_client_id: this.client_list[this.targetRow].t_client_id,
        brander_client_id: item.client_id,
      };
      let handle = () => {
        item.cancelVisible = false;
        item.is_follow = 0;
      };
      this.__axios(this.cancelFollowBranderUrl, params, handle);
    },
    followBrander(item) {
      let params = {
        t_client_id: this.client_list[this.targetRow].t_client_id,
        brander_client_id: item.client_id,
      };
      let handle = () => {
        this.getClientFollowBranderList();
      };
      this.__axios(this.followBranderUrl, params, handle);
    },
    searchBranderList() {
      if (this.branderSearchWord) {
        let params = {
          keyword: this.branderSearchWord,
          t_client_id: this.client_list[this.targetRow].t_client_id,
        };
        let handle = (res) => {
          res.data.content.client_list.forEach((item) => {
            this.$set(item, "cancelVisible", false);
            this.$set(item, "visible", false);
          });
          this.branderList = res.data.content.client_list;
        };
        this.__axios(this.ClientListURL, params, handle);
      }
    },

    setMansionDelivery(value, row) {
      const url = value
        ? "bmuser/set_has_mansion_delivery"
        : "bmuser/unset_has_mansion_delivery";
      const err = (res) => {
        row.has_mansion_delivery = !value;
        this.$message.error(res.data.content.desc);
      };
      this.__axios(
        this.getDomain() + url,
        { client_id: row.client_id },
        () => {},
        () => {},
        err
      );
    },

    setMeituanPage(value, row) {
      const url = "bmuser/set_waimai_meituan_page";
      const type = value ? 1 : 0;
      const err = (res) => {
        row.waimai_meituan_page = !value;
        this.$message.error(res.data.content.desc);
      };
      this.__axios(
        this.getDomain() + url,
        { t_client_id: row.t_client_id, type },
        () => {},
        () => {},
        err
      );
    },

    switchToMinfu(value) {
      const target = this.client_list[this.targetRow];
      if (!value) {
        target.has_minfu = !value;
      } else {
        const url = this.getDomain() + "bmuser/switch_to_minfu";
        const params = {
          minfu_rate: (target.minfu_rate / 100).toString(),
          t_client_id: target.t_client_id,
        };
        const handle = () => {
          this.$message.success("切换成功");
          this.rate = target.minfu_rate;
          target.has_minfu = true;
        };
        const errorHandler = (res) => {
          this.$message.error(res.data.content.desc);
          target.has_minfu = false;
          this.rateType = "0";
        };
        const onCancel = () => {
          target.has_minfu = false;
          this.rateType = "0";
        };
        this.__confirm(
          "<p>· 切换提现方式后，将不再支持提现到微信零钱，只能提现到银行卡，请告知用户</p><br>" +
            "<p>· 用户账户余额大于2元时，不能切换，请先通知用户提现后再操作</p><br>" +
            "<p>· 如果切换前用户仍有待结算订单，待所有待结算都到账后，将通过微信零钱打给用户</p><br>" +
            "<p>· 用户账户余额小于2元时，可以切换，如果切换前没有未结算订单，则切换后将余额通过微信零钱打给用户；如果有未结算订单，则同上一条一并打给用户</p>",
          this.__axios,
          [url, params, handle, () => {}, errorHandler],
          onCancel,
          true
        );
      }
    },
    changeRate() {
      const target = this.client_list[this.targetRow];
      const url = this.getDomain() + "bmuser/change_withdraw_fee_rate";
      const params = {
        type: Number(this.rateType),
        client_id: target.client_id,
        rate: (this.rate / 100).toFixed(3),
      };
      const handle = () => {
        this.changingRate = false;
        this.$message.success("修改成功");
        if (this.rateType === "0") {
          target.weixin_rate = this.rate;
        } else {
          target.minfu_rate = this.rate;
        }
      };
      this.__axios(url, params, handle);
    },
    addrDialog(row) {
      if (row.is_mansion_seller) {
        this.t_client_id = row.t_client_id;
        this.addrDialogVisible = true;
      } else {
        this.$message.error("请先将其设置为点餐大使");
      }
    },
    usrExchange() {
      this.userExchangeVisible = true;
    },
    changeSwitchDS($event, row, url) {
      let params = {
        t_client_id: row.t_client_id,
        type: $event,
      };
      let handle = () => {
        this.$message.success("操作成功");
      };
      let errorHandler = (res) => {
        row.is_mansion_seller = !$event;
        this.$message.error(res.data.content.desc);
      };
      let onCancel = (res) => {
        row.is_mansion_seller = !$event;
      };
      let info = "确认？";
      this.__confirm(
        info,
        this.__axios,
        [this.getDomain() + url, params, handle, () => {}, errorHandler],
        onCancel
      );
    },
    getStoreList() {
      const url = this.getDomain() + "bmuser/get_store_list";
      const params = {
        t_client_id: this.client_list[this.targetRow].t_client_id,
      };
      const handle = (res) => {
        this.$set(
          this.targetShopList,
          0,
          res.data.content.store_list.filter(
            (item) => item.delivery_id === "MTPS"
          )[0] || {
            client_id: undefined,
            delivery_id: "MTPS",
            is_active: undefined,
            store_id: undefined,
          }
        );
        this.$set(
          this.targetShopList,
          1,
          res.data.content.store_list.filter(
            (item) => item.delivery_id === "DADA"
          )[0] || {
            client_id: undefined,
            delivery_id: "DADA",
            is_active: undefined,
            store_id: undefined,
          }
        );
        this.$set(
          this.targetShopList,
          2,
          res.data.content.store_list.filter(
            (item) => item.delivery_id === "SFTC"
          )[0] || {
            client_id: undefined,
            delivery_id: "SFTC",
            is_active: undefined,
            store_id: undefined,
          }
        );
        this.dialogVisible = true;
      };
      const errHandler = (res) => {
        this.$message.error(res.data.content.desc);
        this.dialogVisible = false;
      };
      this.__axios(url, params, handle, () => {}, errHandler);
    },
    getStoreDetail(id) {
      if (id) {
        const url = this.getDomain() + "bmuser/get_store_detail";
        const params = {
          store_id: id,
        };
        const handle = (res) => {
          this.shopInfo = res.data.content.store_detail;
        };
        this.__axios(url, params, handle);
      }
    },
    useStore(id, index) {
      const url = this.getDomain() + "bmuser/use_store";
      const params = {
        store_id: id,
        client_id: this.client_list[this.targetRow].client_id,
      };
      const handle = () => {
        this.targetShopList.forEach((item) => {
          item.is_active = 0;
        });
        this.targetShopList[index].is_active = 1;
      };
      this.__axios(url, params, handle);
    },
    clickTag(row, tagNum) {
      row.shop_size = row.shop_size !== tagNum ? tagNum : 0;
      this.modifyBranderShopSize(row.shop_size, row.client_id);
    },
    modifyBranderShopSize(val, clientId) {
      let params = {
        t_client_id: this.client_list[this.targetRow].t_client_id,
        client_id: clientId,
        shop_size: val,
      };
      let handle = () => {
        this.$message.success("设置成功");
      };
      const errHandler = (res) => {
        this.$message.error(res.data.content.desc);
      };
      this.__axios(
        this.modifyBranderShopSizeUrl,
        params,
        handle,
        () => {},
        errHandler
      );
    },
    writeOff(scope) {
      console.log(scope);
      const params = {
        t_client_id: scope.row.t_client_id,
        type: 1,
      };
      const handle = (res) => {
        scope.row.writeOffVisible = false;
        scope.row.is_cancel = 1;
        this.$message.success("注销成功！");
      };
      this.__axios(this.accountCancelOrRecovery, params, handle);
    },
    recover(scope) {
      const params = {
        t_client_id: scope.row.t_client_id,
        type: 0,
      };
      const handle = (res) => {
        scope.row.is_cancel = 0;
        this.$message.success("恢复成功！");
      };
      this.__axios(this.accountCancelOrRecovery, params, handle);
    },
    changeScore(row) {
      console.log(row.score);
      const target = this.client_list[this.targetRow];
      const url = this.getDomain() + "bmclient/set_brander_score";
      const params = {
        t_client_id: target.t_client_id,
        client_id: row.client_id,
        score: (+row.score).toFixed(1),
      };
      const handle = () => {
        row.changingScore = false;
        this.$message.success("修改成功");
      };
      const errorHandler = (res) => {
        this.$message.error(res.data.content.desc);
        this.getClientFollowBranderList();
        row.changingScore = false;
      };
      this.__axios(url, params, handle, () => {}, errorHandler);
    },
  },
  created() {
    this.getList();
    this.getBotList();
  },
};
</script>

<style scoped>
p {
  cursor: pointer;
  color: #3a8ee6;
}

img {
  width: 30px;
  height: 30px;
}

.group-buy-info {
  cursor: pointer;
  font-size: 14px;
  color: #0ca9b5;
}

.a-icon {
  background-color: #3a8ee6;
  border-radius: 50%;
  width: 50px;
  height: 50px;
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: center;
}
.tag-item:not(:last-child) {
  margin-right: 10px;
}
.write-off {
  float: left;
  color: red;
  padding-left: 40px;
}
.projectdialog /deep/ .el-form-item__error {
  margin-left: 100px;
}
</style>
